/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import {Link} from 'react-router-dom'
// import {KTSVG} from '../../../helpers'
import {Item1} from '../../content/activity/Item1'
import {Item2} from '../../content/activity/Item2'
import {Item3} from '../../content/activity/Item3'
import {Item4} from '../../content/activity/Item4'
import {Item5} from '../../content/activity/Item5'
import {Item6} from '../../content/activity/Item6'
import {Item7} from '../../content/activity/Item7'
import {Item8} from '../../content/activity/Item8'


type Props = {
  className: string
  insights: any
  eventsByType: any
  events_data: any
}


// const formatTimestamp = (timestamp: string) => {
//   if (!timestamp) return '';
  
//   const date = new Date(timestamp);
//   return date.toLocaleString();
// };

// // Function to get event icon based on type or severity
// const getEventIcon = (type: string, severity?: string) => {
//   // Map event types or severity to appropriate icons
//   const iconMap: {[key: string]: string} = {
//     'alert': '/media/icons/duotune/general/gen044.svg',
//     'motion': '/media/icons/duotune/maps/map001.svg',
//     'person': '/media/icons/duotune/communication/com006.svg',
//     'vehicle': '/media/icons/duotune/general/gen025.svg',
//     'object': '/media/icons/duotune/general/gen018.svg',
//     'critical': '/media/icons/duotune/general/gen044.svg',
//     'warning': '/media/icons/duotune/general/gen007.svg',
//     'info': '/media/icons/duotune/general/gen055.svg',
//   };
  
//   // Return the appropriate icon or a default one
//   return iconMap[severity || type] || '/media/icons/duotune/general/gen055.svg';
// };

// // Function to get background color based on type or severity
// const getBgColor = (type: string, severity?: string) => {
//   // Map event types or severity to appropriate background colors
//   const bgColorMap: {[key: string]: string} = {
//     'alert': 'danger',
//     'motion': 'primary',
//     'person': 'success',
//     'vehicle': 'warning',
//     'object': 'info',
//     'critical': 'danger',
//     'warning': 'warning',
//     'info': 'info',
//   };
  
//   // Return the appropriate background color or a default one
//   return bgColorMap[severity || type] || 'primary';
// };

// // Combine insights and events for the timeline
// const timelineItems = [
//   ...insights.map(insight => ({
//     ...insight,
//     itemType: 'insight',
//   })),
//   ...eventsByType.map(event => ({
//     ...event,
//     itemType: 'event',
//   }))
// ].sort((a, b) => {
//   // Sort by timestamp (newest first)
//   return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
// });

// // Count total activities for display
// const totalActivities = insights.length + eventsByType.reduce((total, event) => total + (event.count || 1), 0);


const ListsWidget5: React.FC<Props> = ({className, events_data}) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header align-items-center border-0 mt-4'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='fw-bolder mb-2 text-dark'>Activity Logs</span>
          <span className='text-muted fw-bold fs-7'>{events_data?.pagination?.total} Activities</span>
        </h3>
        <div className='card-toolbar'>
          {/* begin::Menu */}
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          <Dropdown1 />
          {/* end::Menu */}
        </div>
      </div>
      
      <div className='card shadow-none rounded-0'>
      
      <div className='card-body position-relative' id='kt_activities_body'>
        <div
          id='kt_activities_scroll'
          className='position-relative scroll-y me-n5 pe-5'
          data-kt-scroll='true'
          data-kt-scroll-height='auto'
          data-kt-scroll-wrappers='#kt_activities_body'
          data-kt-scroll-dependencies='#kt_activities_header, #kt_activities_footer'
          data-kt-scroll-offset='5px'
        >
          <div className='timeline'>
           {
            events_data.events.length > 0 ?
            events_data.events.map((ele: any, i: number) => {
              return (
                <Item1 key = {i}/>
                // <Item5 />
                // <Item7 />
              )
            })
            :
            (
              <div className='text-center py-10'>
                <div className='mb-3'>
                  <KTSVG
                    path='/media/icons/duotune/files/fil024.svg'
                    className='svg-icon-3x svg-icon-muted'
                  />
                </div>
                <div className='fw-bold text-gray-600 fs-5 mb-2'>No Activity Data Available</div>
                <div className='text-muted'>
                  Events and insights will appear here when they are generated.
                </div>
              </div>
            )
           }
          </div>
        </div>
      </div>
      <div className='card-footer py-5 text-center' id='kt_activities_footer'>
        <Link to='/events' className='btn btn-bg-white text-primary'>
          View All Activities
          <KTSVG
            path='/media/icons/duotune/arrows/arr064.svg'
            className='svg-icon-3 svg-icon-primary'
          />
        </Link>
      </div>
    </div>

    </div>
  )
}

export {ListsWidget5}
